import {
  faArrowUpRightAndArrowDownLeftFromCenter,
  faCirclePlus,
  faEllipsis,
  faPenToSquare,
} from '@awesome.me/kit-4a6bf60416/icons/classic/regular';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Icon } from '@/components/ui/icon';

interface ImageMenuProps {
  onAddToSiteFiles: () => void;
  onCrop?: () => void;
  onPreview?: () => void;
  onOpenChange: (open: boolean) => void;
}

export function ImageMenu({ onAddToSiteFiles, onCrop, onPreview, onOpenChange }: ImageMenuProps) {
  const handleMenuItemSelect = (action: () => void) => (e: Event) => {
    e.preventDefault();
    action();
    onOpenChange(false);
  };

  return (
    <div className="flex justify-end">
      <DropdownMenu onOpenChange={onOpenChange}>
        <DropdownMenuTrigger asChild>
          <Button size="icon-sm" colorScheme="secondary">
            <Icon icon={faEllipsis} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-[185px] z-50">
          <DropdownMenuItem onSelect={handleMenuItemSelect(onAddToSiteFiles)}>
            <Icon icon={faCirclePlus} />
            Add to Site Files
          </DropdownMenuItem>
          <DropdownMenuItem
            onSelect={onCrop ? handleMenuItemSelect(onCrop) : undefined}
            disabled={!onCrop}
          >
            <Icon icon={faPenToSquare} />
            Crop
          </DropdownMenuItem>
          <DropdownMenuItem
            onSelect={onPreview ? handleMenuItemSelect(onPreview) : undefined}
            disabled={!onPreview}
          >
            <Icon icon={faArrowUpRightAndArrowDownLeftFromCenter} />
            Preview
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
